import type { Oportunidade } from "@base/contracts";
import type { ColunaDaTabela } from "@base/ui";
import { ROTULO_DA_ETAPA } from "../domain/funil";
import { formatar } from "../domain/formatadores";

function Celula({ valor }: { readonly valor: string }) {
  return (
    <span className="block max-w-52 truncate whitespace-nowrap" title={valor}>
      {valor}
    </span>
  );
}

export const COLUNAS_DA_OPORTUNIDADE: readonly ColunaDaTabela<Oportunidade>[] = [
  {
    chave: "lead",
    titulo: "Oportunidade",
    celula: (item) => {
      const nome = item.nome.trim() || `#${item.leadId}`;
      return (
        <span className="flex min-w-36 flex-col">
          <Celula valor={nome} />
          {item.nome.trim() ? <span className="text-xs text-muted-foreground">#{item.leadId}</span> : null}
        </span>
      );
    },
  },
  { chave: "origem", titulo: "Origem", celula: (item) => <Celula valor={item.origem ?? "Não informado"} /> },
  { chave: "utm-campaign", titulo: "Campanha", celula: (item) => <Celula valor={item.utmCampaign ?? "—"} /> },
  {
    chave: "utm-conjunto",
    titulo: "Conjunto",
    ocultarNoCelular: true,
    celula: (item) => <Celula valor={item.utmConjunto ?? "—"} />,
  },
  {
    chave: "utm-anuncio",
    titulo: "Anúncio",
    ocultarNoCelular: true,
    celula: (item) => <Celula valor={item.utmAnuncio ?? "—"} />,
  },
  { chave: "criado", titulo: "Criado em", celula: (item) => formatar.data(item.criadoEm) },
  {
    chave: "primeira-resposta",
    titulo: "Primeira resposta",
    numerica: true,
    celula: (item) => formatar.duracao(item.primeiraRespostaMinutos),
  },
  {
    chave: "etapa",
    titulo: "Etapa atual",
    ocultarNoCelular: true,
    celula: (item) => (item.etapaAtual ? ROTULO_DA_ETAPA[item.etapaAtual] : "Fora do funil"),
  },
  {
    chave: "valor",
    titulo: "Valor",
    numerica: true,
    celula: (item) => formatar.moeda(item.valorCentavos / 100),
  },
];
